import { render, staticRenderFns } from "./permsTransferDialog.vue?vue&type=template&id=142dc98d&"
import script from "./permsTransferDialog.vue?vue&type=script&lang=js&"
export * from "./permsTransferDialog.vue?vue&type=script&lang=js&"
import style0 from "./permsTransferDialog.vue?vue&type=style&index=0&id=142dc98d&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports